import Divider from './Divider'
export default Divider
export type { IDivider } from './Divider.types'
